// Español.
export default {
    'canvas.title': 'Contenido de la página',
    'canvas.loading': 'Cargando el editor…',
    'empty.title': 'Empieza tu página',
    'empty.text': 'Arrastra aquí un bloque o una sección lista para usar, o haz clic en uno para añadirlo.',
    'empty.sections': 'Ver las secciones',
    'empty.blocks': 'Añadir un bloque',

    'panel.insert': 'Añadir',
    'panel.settings': 'Ajustes',
    'panel.content': 'Contenido',
    'panel.layout': 'Diseño',
    'panel.style': 'Estilo',
    'panel.visibility': 'Visibilidad',
    'panel.advanced': 'Avanzado',
    'tab.blocks': 'Bloques',
    'tab.sections': 'Secciones',
    'tab.layers': 'Capas',
    'category.layout': 'Diseño',
    'category.basic': 'Básicos',
    'category.media': 'Multimedia',
    'category.components': 'Componentes',
    'category.advanced': 'Avanzado',
    'palette.hint': 'Arrastra a la página o haz clic para añadir',
    'palette.none': 'Ningún bloque coincide con tu búsqueda.',
    'sections.intro': 'Arrastra una sección a la página o haz clic para añadirla. Todo sigue siendo editable.',
    'layers.empty': 'La página está vacía.',
    'inspector.empty': 'Selecciona un bloque de la página para editar su contenido y su estilo.',
    'inspector.path': 'Posición en la página',

    'device.label': 'Tamaño de la vista previa',
    'device.desktop': 'Ordenador',
    'device.tablet': 'Tableta',
    'device.mobile': 'Teléfono',

    'action.undo': 'Deshacer',
    'action.redo': 'Rehacer',
    'action.guides': 'Mostrar los contornos de los bloques',
    'action.preview': 'Vista previa',
    'action.code': 'Editar el código',
    'action.copyCode': 'Copiar el código',
    'action.fullscreen': 'Pantalla completa',
    'action.selectParent': 'Seleccionar el bloque padre',
    'action.move': 'Arrastrar para mover',
    'action.moveUp': 'Subir',
    'action.moveDown': 'Bajar',
    'action.duplicate': 'Duplicar',
    'action.remove': 'Eliminar',
    'action.close': 'Cerrar',
    'action.apply': 'Aplicar',
    'action.cancel': 'Cancelar',
    'action.clear': 'Borrar',
    'action.search': 'Buscar',
    'action.searchBlocks': 'Buscar un bloque…',
    'action.addColumn': 'Añadir una columna',
    'action.equalize': 'Anchos iguales',
    'action.addButton': 'Añadir un botón',
    'action.addItem': 'Añadir un elemento',
    'action.resizeColumns': 'Arrastrar para cambiar el ancho de las columnas',
    'category.saved': 'Guardados',
    'action.saveBlock': 'Guardar como bloque reutilizable',
    'action.save': 'Guardar',
    'action.restore': 'Restaurar',
    'saved.name': 'Nombre del bloque',
    'saved.help': 'El bloque y todo su contenido aparecerán en Bloques › Guardados, para esta página y las siguientes.',
    'saved.done': 'Bloque guardado: lo encontrarás en Bloques › Guardados.',
    'saved.remove': 'Quitar este bloque guardado',
    'notice.draftFound': 'Los cambios del {date} no se guardaron.',
    'error.storage': 'El navegador no ha podido guardar este bloque (almacenamiento lleno o desactivado).',

    'shortcut.undo': 'deshacer',
    'shortcut.duplicate': 'duplicar',
    'shortcut.move': 'subir o bajar',
    'shortcut.remove': 'eliminar',
    'shortcut.parent': 'seleccionar el padre',
    'shortcut.edit': 'editar el texto',

    'block.container': 'Contenedor',
    'block.containerFluid': 'Ancho completo',
    'block.box': 'Caja',
    'block.row': 'Fila',
    'block.col': 'Columna',
    'block.heading': 'Título',
    'block.text': 'Texto',
    'block.quote': 'Cita',
    'block.list': 'Lista',
    'block.table': 'Tabla',
    'block.button': 'Botón',
    'block.separator': 'Separador',
    'block.spacer': 'Espacio',
    'block.icon': 'Icono',
    'block.html': 'HTML',
    'block.image': 'Imagen',
    'block.video': 'Vídeo',
    'block.embed': 'Página incrustada',
    'block.map': 'Mapa',
    'block.card': 'Tarjeta',
    'block.accordion': 'Acordeón',
    'preset.cols1': '1 columna',
    'preset.cols2': '2 columnas',
    'preset.cols3': '3 columnas',
    'preset.cols4': '4 columnas',
    'preset.cols84': '2/3 + 1/3',
    'preset.cols48': '1/3 + 2/3',
    'preset.cols363': '1/4 + 1/2 + 1/4',
    'preset.cols6': '6 columnas',

    'placeholder.heading': 'Tu título',
    'placeholder.text': 'Escribe aquí tu texto. Selecciona palabras para ponerlas en negrita, en cursiva o como enlace.',
    'placeholder.quote': 'Una gran cita, breve y memorable.',
    'placeholder.author': 'Nombre del autor',
    'placeholder.item': 'Elemento',
    'placeholder.column': 'Columna',
    'placeholder.button': 'Haz clic aquí',
    'placeholder.readMore': 'Leer más',
    'placeholder.caption': 'Pie de la imagen',
    'placeholder.cardTitle': 'Título de la tarjeta',
    'placeholder.cardText': 'Una breve descripción que invita a saber más.',
    'placeholder.question': 'Pregunta',
    'placeholder.answer': 'La respuesta, en unas pocas frases claras.',
    'placeholder.html': 'Tu código HTML',
    'placeholder.address': 'Torre Eiffel, París',

    'field.width': 'Ancho',
    'field.tag': 'Etiqueta HTML',
    'field.gutters': 'Espacio entre columnas',
    'field.justify': 'Alineación horizontal',
    'field.alignItems': 'Alineación vertical',
    'field.alignSelf': 'Alineación vertical en la fila',
    'field.columnWidth': 'Ancho según la pantalla',
    'field.level': 'Nivel',
    'field.size': 'Tamaño',
    'field.thickness': 'Grosor',
    'field.opacity': 'Opacidad',
    'field.height': 'Altura',
    'field.icon': 'Icono',
    'field.filled': 'Relleno',
    'field.image': 'Imagen',
    'field.alt': 'Texto alternativo',
    'field.link': 'Enlace',
    'field.newTab': 'Abrir en una pestaña nueva',
    'field.caption': 'Pie de imagen',
    'field.align': 'Alineación',
    'field.ratio': 'Proporciones',
    'field.corners': 'Esquinas',
    'field.shadow': 'Sombra',
    'field.videoUrl': 'Vídeo',
    'field.controls': 'Mostrar los controles',
    'field.autoplay': 'Reproducción automática (sin sonido)',
    'field.loop': 'En bucle',
    'field.muted': 'Sin sonido',
    'field.url': 'Dirección (URL)',
    'field.address': 'Dirección',
    'field.zoom': 'Zoom',
    'field.showImage': 'Mostrar una imagen',
    'field.titleLevel': 'Nivel del título',
    'field.showButton': 'Mostrar un botón',
    'field.firstOpen': 'Primer elemento abierto',
    'field.items': 'Elementos',
    'field.question': 'Pregunta',
    'field.text': 'Texto',
    'field.style': 'Estilo',
    'field.code': 'Código HTML',
    'field.textAlign': 'Alineación del texto',
    'field.spacing': 'Espaciado',
    'field.margin': 'Margen exterior',
    'field.padding': 'Margen interior',
    'field.background': 'Fondo',
    'field.backgroundImage': 'Imagen de fondo',
    'field.textColor': 'Color del texto',
    'field.border': 'Borde',
    'field.showOn': 'Mostrar en',
    'field.id': 'Ancla (ID)',
    'field.classes': 'Clases CSS',
    'field.inlineStyle': 'Estilo en línea',
    'side.t': 'arriba',
    'side.b': 'abajo',
    'side.s': 'a la izquierda',
    'side.e': 'a la derecha',

    'help.alt': 'Describe la imagen para quienes no pueden verla y para los buscadores.',
    'help.video': 'Un enlace de YouTube o Vimeo, o la dirección de un archivo MP4.',
    'help.embed': 'La dirección de una página que acepta ser incrustada (un formulario, un calendario…).',
    'help.columnWidth': 'Primero el teléfono: un tamaño vacío usa el de la pantalla más pequeña, mostrado en gris.',
    'help.visibility': 'Desmarca un tamaño para ocultar el bloque en esas pantallas.',
    'help.id': 'Permite que un enlace apunte a este bloque: #ancla.',
    'help.classes': 'Clases de tu tema o de Bootstrap, separadas por espacios.',
    'help.accordion': 'Haz clic en una pregunta o una respuesta de la página para editar su texto.',
    'help.html': 'Los scripts y los atributos de evento se eliminan por seguridad.',

    'option.default': 'Por defecto',
    'option.none': 'Ninguno',
    'option.auto': 'Auto',
    'option.fill': 'Rellenar',
    'option.inherit': 'Heredar',
    'option.custom': 'Color personalizado',
    'option.boxed': 'Centrado',
    'option.fullWidth': 'Ancho completo',
    'option.start': 'Izquierda',
    'option.center': 'Centro',
    'option.end': 'Derecha',
    'option.between': 'Repartido',
    'option.top': 'Arriba',
    'option.middle': 'Centro',
    'option.bottom': 'Abajo',
    'option.wrapLeft': 'Izquierda, texto alrededor',
    'option.wrapRight': 'Derecha, texto alrededor',
    'option.original': 'Original',
    'option.square': 'Rectas',
    'option.rounded': 'Redondeadas',
    'option.pill': 'Píldora',
    'option.circle': 'Círculo',
    'option.small': 'Pequeña',
    'option.medium': 'Mediana',
    'option.large': 'Grande',
    'button.primary': 'Principal',
    'button.outline-primary': 'Principal, contorno',
    'button.secondary': 'Secundario',
    'button.outline-secondary': 'Secundario, contorno',
    'button.success': 'Éxito',
    'button.outline-success': 'Éxito, contorno',
    'button.danger': 'Peligro',
    'button.outline-danger': 'Peligro, contorno',
    'button.warning': 'Aviso',
    'button.outline-warning': 'Aviso, contorno',
    'button.info': 'Info',
    'button.outline-info': 'Info, contorno',
    'button.light': 'Claro',
    'button.outline-light': 'Claro, contorno',
    'button.dark': 'Oscuro',
    'button.outline-dark': 'Oscuro, contorno',
    'button.link': 'Enlace',

    'rte.toolbar': 'Formato del texto',
    'rte.format': 'Estilo de párrafo',
    'rte.paragraph': 'Párrafo',
    'rte.lead': 'Entradilla',
    'rte.small': 'Texto pequeño',
    'rte.table': 'Tabla…',
    'rte.rowAbove': 'Insertar una fila encima',
    'rte.rowBelow': 'Insertar una fila debajo',
    'rte.colLeft': 'Insertar una columna a la izquierda',
    'rte.colRight': 'Insertar una columna a la derecha',
    'rte.deleteRow': 'Eliminar la fila',
    'rte.deleteCol': 'Eliminar la columna',
    'rte.deleteTable': 'Eliminar la tabla',
    'rte.heading': 'Título {n}',
    'rte.quote': 'Cita',
    'rte.code': 'Código',
    'rte.bold': 'Negrita (Ctrl+B)',
    'rte.italic': 'Cursiva (Ctrl+I)',
    'rte.underline': 'Subrayado (Ctrl+U)',
    'rte.strike': 'Tachado',
    'rte.link': 'Enlace (Ctrl+K)',
    'rte.unlink': 'Quitar el enlace',
    'rte.bulletList': 'Lista con viñetas',
    'rte.numberedList': 'Lista numerada',
    'rte.alignLeft': 'Alinear a la izquierda',
    'rte.alignCenter': 'Centrar',
    'rte.alignRight': 'Alinear a la derecha',
    'rte.justify': 'Justificar',
    'rte.clear': 'Borrar el formato',

    'media.upload': 'Subir',
    'media.library': 'Elegir',
    'media.urlOnly': 'Pega la dirección del archivo. Enviar archivos del ordenador necesita una dirección de subida (opción uploadUrl).',
    'media.embedded': 'Imagen guardada en la página',

    'code.title': 'Código HTML de la página',
    'code.help': 'Edita el código y aplícalo: PageFlow vuelve a encontrar sus bloques. Los scripts se eliminan.',

    'notice.copied': 'Código copiado al portapapeles',
    'notice.noGrid': 'Los estilos del sitio no se han cargado en el editor: mientras tanto se usa una cuadrícula sencilla. Revisa la opción canvasStyles.',
    'notice.codeApplied': 'Código aplicado',
    'notice.cannotInsert': 'Este bloque no puede ir aquí. Selecciona primero una columna o un contenedor.',
    'error.copy': 'No se ha podido copiar el código. Selecciónalo en la vista del código.',
    'error.fileType': 'Este tipo de archivo no se acepta aquí.',
    'error.fileSize': 'Este archivo es demasiado grande (máximo {size} MB).',
    'error.upload': 'No se ha podido subir el archivo.',
    'error.noUpload': 'No hay ninguna dirección de subida: los archivos del ordenador no se pueden enviar. Pega la dirección del archivo (desarrolladores: opción uploadUrl, gestor PHP incluido).',

    'sec.heroSplit': 'Portada con imagen',
    'sec.heroSplitDesc': 'Título, texto y botones junto a una foto.',
    'sec.heroCenter': 'Portada centrada',
    'sec.heroCenterDesc': 'Un gran mensaje centrado sobre una banda clara.',
    'sec.features': 'Puntos fuertes',
    'sec.featuresDesc': 'Tres puntos fuertes con iconos.',
    'sec.imageText': 'Imagen y texto',
    'sec.imageTextDesc': 'Una foto junto a un texto y una lista.',
    'sec.cta': 'Llamada a la acción',
    'sec.ctaDesc': 'Una banda de color con un botón claro.',
    'sec.cards': 'Tarjetas',
    'sec.cardsDesc': 'Tres artículos, productos o servicios.',
    'sec.testimonials': 'Testimonios',
    'sec.testimonialsDesc': 'Lo que tus clientes dicen de ti.',
    'sec.pricing': 'Precios',
    'sec.pricingDesc': 'Tres planes uno al lado del otro.',
    'sec.faq': 'Preguntas frecuentes',
    'sec.faqDesc': 'Preguntas y respuestas que se abren con un clic.',
    'sec.stats': 'Cifras clave',
    'sec.statsDesc': 'Cuatro cifras que inspiran confianza.',
    'sec.team': 'Equipo',
    'sec.teamDesc': 'Retratos con nombres y cargos.',
    'sec.contact': 'Contacto',
    'sec.contactDesc': 'Dirección, teléfono y correo junto a un mapa.',
    'sec.gallery': 'Galería',
    'sec.galleryDesc': 'Seis fotos en cuadrícula.',
    'sec.heroTitle': 'Crea páginas bonitas en minutos',
    'sec.heroText': 'Arrastra, suelta y escribe: tu página está lista, adaptada a móviles y limpia, sin escribir una sola línea de código.',
    'sec.getStarted': 'Empezar',
    'sec.learnMore': 'Saber más',
    'sec.contactUs': 'Contáctanos',
    'sec.imageAlt': 'Foto',
    'sec.centerTitle': 'Todo lo que necesitas, nada que sobre',
    'sec.centerText': 'Una promesa sencilla que dice a tus visitantes que están en el lugar adecuado.',
    'sec.featuresTitle': 'Por qué elegirnos',
    'sec.featuresText': 'Tres buenas razones, en pocas palabras.',
    'sec.feature1': 'Rápido',
    'sec.feature2': 'Fiable',
    'sec.feature3': 'Pensado para móviles',
    'sec.featureText': 'Describe este punto fuerte en una o dos frases que hablen a tus visitantes.',
    'sec.imageTextTitle': 'Cuenta tu historia',
    'sec.imageTextText': 'Explica lo que haces y cómo ayudas, con las palabras de tus clientes.',
    'sec.point1': 'Una primera ventaja',
    'sec.point2': 'Una segunda ventaja',
    'sec.point3': 'Una tercera ventaja',
    'sec.ctaTitle': '¿Listo para empezar?',
    'sec.ctaText': 'Únete a quienes ya confían en nosotros. Solo lleva un minuto.',
    'sec.cardsTitle': 'Últimas noticias',
    'sec.cardTitle': 'Un título de tarjeta',
    'sec.cardText': 'Un breve resumen que invita a seguir leyendo.',
    'sec.readMore': 'Leer más',
    'sec.testimonialsTitle': 'Lo que dicen nuestros clientes',
    'sec.quote1': 'Sencillo, rápido y bonito. Rehicimos toda nuestra web en un fin de semana.',
    'sec.quote2': 'El soporte respondió en menos de una hora. Lo recomiendo sin dudarlo.',
    'sec.quote3': 'Nuestros visitantes se quedan más tiempo y nos contactan más desde las nuevas páginas.',
    'sec.name1': 'Emma Lawson',
    'sec.name2': 'Lucas Martín',
    'sec.name3': 'Sofía Rossi',
    'sec.role1': 'Fundadora, Studio Norte',
    'sec.role2': 'Gerente, Puerto Azul',
    'sec.role3': 'Directora, Atelier Verde',
    'sec.pricingTitle': 'Precios sencillos',
    'sec.pricingText': 'Sin costes ocultos. Cambia o cancela cuando quieras.',
    'sec.plan1': 'Básico',
    'sec.plan2': 'Profesional',
    'sec.plan3': 'Empresa',
    'sec.month': 'mes',
    'sec.benefit1': 'Una primera ventaja',
    'sec.benefit2': 'Una segunda ventaja',
    'sec.benefit3': 'Una tercera ventaja',
    'sec.choose': 'Elegir este plan',
    'sec.faqTitle': 'Preguntas frecuentes',
    'sec.question1': '¿Cómo empiezo?',
    'sec.answer1': 'Elige un plan, crea tu cuenta y sigue la guía: solo lleva unos minutos.',
    'sec.question2': '¿Puedo cambiar de plan más adelante?',
    'sec.answer2': 'Sí, en cualquier momento. La diferencia se calcula por ti.',
    'sec.question3': '¿Ofrecéis asistencia?',
    'sec.answer3': 'Nuestro equipo responde por correo todos los días laborables.',
    'sec.question4': '¿Están seguros mis datos?',
    'sec.answer4': 'Tus datos se guardan de forma segura y nunca se comparten.',
    'sec.stat1': 'clientes satisfechos',
    'sec.stat2': 'de satisfacción',
    'sec.stat3': 'asistencia',
    'sec.stat4': 'países',
    'sec.teamTitle': 'El equipo',
    'sec.member': 'Miembro del equipo',
    'sec.jobTitle': 'Cargo',
    'sec.contactTitle': 'Contacta con nosotros',
    'sec.contactText': 'Nos encantará saber de ti. Escríbenos o ven a vernos.',
    'sec.addressLabel': 'Dirección',
    'sec.address': '5 Avenue Anatole France, 75007 París',
    'sec.phoneLabel': 'Teléfono',
    'sec.emailLabel': 'Correo',
    'sec.galleryTitle': 'Galería',
};
